export const spaceNumber = ( num ) => {
	if ( num > 999 )
	{
		num += ``;

		num = num
			.split( `` )
			.reverse()
			.join( `` )
			.replace( /\d{3}/g, `$& ` )
			.split( `` ).reverse().join( `` )
			.replace( /^ /, `` );
	}

	return num;
};
